/* Shopiy commons start */

/*
 * Shopify Common JS
 *
 */

// set a given selector with value, if value is one of the options
Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

// send request as a POST
Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options["method"] || "post";
  const params = options["parameters"] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

/* CountryProvinceSelector
 * js class that adds listener to country selector and on change updates
 * province selector with valid province values.
 * Selector should be in this format:
 *
 *   <select id="country_selector" name="country" data-default="Canada">
 *     <option data-provinces="['Alberta','Ontario','British Columbia',...] value="Canada">Canada</option>
 *     ...
 *   </select>
 *   <select id="province_selector" name="province" data-default="Ontario">
 *     <option value="Ontario">Ontario</option>
 *     ...
 *   </select>
 */
Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  this.countryEl.addEventListener("change", this.countryHandler.bind(this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    const opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      this.setOptions(this.provinceEl, provinces);
      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i][0];
      opt.innerHTML = values[i][1];
      selector.appendChild(opt);
    }
  },
};

/* shopify commons end */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

// Enable tabbing only for focusable elements inside the container
function enableTabbing(container) {
  console.log(container, "cont");
  const focusableElements = getFocusableElements(container);
  console.log(focusableElements, "open");
  focusableElements.forEach((element) => {
    element.removeAttribute("tabindex"); // Restore the element's tabindex
  });
}

// Disable tabbing on elements inside the container
function disableTabbing(container) {
  console.log(container, "cont disable");
  const focusableElements = getFocusableElements(container);
  console.log(focusableElements, "close");
  focusableElements.forEach((element) => {
    element.setAttribute("tabindex", "-1"); // Disable focus on the element
  });
}

const trapFocusHandlers = {
  focusin: null,
  focusout: null,
  keydown: null,
};

function trapFocus(container, elementToFocus = container) {
  // Get all focusable elements within the container
  const elements = getFocusableElements(container);

  if (elements.length > 0) {
    const first = elements[0];
    const last = elements[elements.length - 1];

    // Remove existing trapFocus event listeners if any
    removeTrapFocus();

    // Define handlers for focusin and focusout events
    trapFocusHandlers.focusin = function (event) {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) {
        return;
      }

      // Add keydown listener when focus is inside the container
      document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
      // Clean up keydown listener on focus out
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    // Add focusin and focusout listeners to trap focus
    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    // Add keydown listener to trap tab navigation
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== "TAB") return; // If not TAB key

      // On the last focusable element and tab forward, focus the first element
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      // On the first focusable element and tab backward, focus the last element
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };

    // Focus the provided element or the first element by default
    console.log(elementToFocus, "el to focus?");
    elementToFocus.focus();

    // If the element is a text input, automatically select its text
    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

// Remove trap focus event listeners
function removeTrapFocus() {
  if (trapFocusHandlers.focusin) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    trapFocusHandlers.focusin = null;
  }

  if (trapFocusHandlers.focusout) {
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    trapFocusHandlers.focusout = null;
  }

  if (trapFocusHandlers.keydown) {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
    trapFocusHandlers.keydown = null;
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class SubscriptionSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onSubscriptionOptionChange);
  }

  /*
  1. update otp radio and save DONE!
  2. update sub freq and save DONE!
  3. update price DONE
  3. able and disable values according to if otp or sub, if sub: enable selling-plan, selling-plan-option, if otp: disable DONE
  7. remove the option for products without selling plan DONE
    10. variants price update DONE

  8. client should be able to select if otp or sub should be preselected
  9. exceptions e.g. sale products lol DONE
  */

  /*
    Info about variants:
    variants have same prices that's why I'm not cross checking subs on variant change etc.
    Variants are only available for clothing items atm, if this changes we need to build in an exception
  */

  onSubscriptionOptionChange() {
    this.init();
  }

  getPriceString() {
    const priceString = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: window.currencyStrings.currency,
      trailingZeroDisplay: "stripIfInteger",
    }).format(this.newPrice / 100);

    return priceString;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.getSelectedPurchaseOption();

    if (this.selectedPurchaseOption?.value === "subscription") {
      this.getSelectedPlan();
      this.getRightPrice();
      this.toggleAddButton(false, "");
      this.changeSubPrice();
      this.toggleSelect(true);
    } else {
      this.getRightPrice(false);
      this.toggleAddButton(false, "");
      this.toggleSelect(false);
    }

    this.updateSellingPlanInputs();
  }

  toggleSelect(subscription) {
    const planSelect = this.getSelectedPlan();
    if (!planSelect) return;

    if (subscription) {
      planSelect.disabled = false;
    } else {
      planSelect.disabled = true;
    }
  }

  getSelectedPlan() {
    this.selectedPlan = this.querySelector("select[name='frequencies']");
    return this.selectedPlan;
  }

  getSelectedPurchaseOption() {
    this.selectedPurchaseOption = this.querySelector(
      "input[name='subscriptions']:checked"
    );
    return this.selectedPurchaseOption;
  }

  /*
  get new price of selected option, data saved in the <option></option> tag

  variants with different prices are NOT supported
  */
  getRightPrice(planSelected = true) {
    if (planSelected) {
      const selectedPlanIndex = this.selectedPlan.selectedIndex;
      if (selectedPlanIndex === -1) return;

      const allPlanOptions = this.selectedPlan.options;
      const selectedOptionPrice =
        allPlanOptions[selectedPlanIndex].getAttribute("data-price");
      this.newPrice = selectedOptionPrice;
    } else {
      this.newPrice = this.dataset.initPrice;
    }
  }

  updateSellingPlanInputs() {
    // check which frequency was selected, this includes the plan id
    const selectedPlan = this.selectedPlan?.value;

    // check if subscription or otp is selected
    const selectedPurchaseOption = this.selectedPurchaseOption?.value;

    // const productForms = document.querySelectorAll(
    //   `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    // );

    const productForms = document.querySelectorAll(`[id^=product-form]`);

    productForms.forEach((productForm) => {
      // change freq/plan:
      let inputSellingPlan = productForm.querySelector(
        'input[name="selling_plan"]'
      );
      inputSellingPlan.value = selectedPlan;
      inputSellingPlan.dispatchEvent(new Event("change", { bubbles: true }));

      // change if sub or otp:
      let inputPurchaseOption = productForm.querySelector(
        'input[name="selling-plan-option"]'
      );

      inputPurchaseOption.value = selectedPurchaseOption;

      /*
        This prevents sending the selling plan id if its a otp
      */
      if (selectedPurchaseOption === "subscription") {
        inputSellingPlan.disabled = false;
      } else {
        inputSellingPlan.disabled = true;
      }

      inputPurchaseOption.dispatchEvent(new Event("change", { bubbles: true }));

      publish(PUB_SUB_EVENTS.subscriptionChange, {
        data: {
          purchase_option: this.selectedPurchaseOption,
          selling_plan: this.selectedPlan,
          new_price: this.newPrice,
        },
      });
    });
  }

  changeSubPrice() {
    const priceSpan = document.querySelector(".js-sub-price");
    if (!priceSpan || !this.newPrice) return;

    priceSpan.textContent = this.newPrice;
  }

  toggleAddButton(disable = true, text) {
    // const productForm = document.getElementById(
    //   `product-form-${this.dataset.section}`
    // );

    const productForms = document.querySelectorAll(`[id^=product-form]`);

    if (!productForms || productForms?.length < 1) return;

    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const comparePriceSpan = productForm.querySelector(".js-atc-compare");
      const addButtonText = productForm.querySelector(
        '[name="add"] > .prices > .js-atc-price'
      );
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        if (this.newPrice) {
          addButtonText.innerHTML = `${
            this.selectedPurchaseOption?.value === "one-time-purchase"
              ? window.variantStrings.addToCart
              : window.variantStrings.subscibe
          } - ${this.newPrice}`;
        } else {
          addButtonText.textContent = `${
            this.selectedPurchaseOption?.value === "one-time-purchase"
              ? window.variantStrings.addToCart
              : window.variantStrings.subscibe
          }`;
        }

        // Compare price update
        if (
          comparePriceSpan !== null &&
          this.newPrice !== this.dataset.initPrice
        ) {
          comparePriceSpan.style.display = "inline";
          comparePriceSpan.innerHTML = `${
            this.selectedPurchaseOption?.value === "one-time-purchase"
              ? this.dataset.comparePrice
              : this.dataset.comparePrice
              ? this.dataset.comparePrice
              : this.dataset.initPrice
          }`;
        }
      }
    });
  }
}

customElements.define("subscription-selects", SubscriptionSelects);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.subscriptionSelects = document.querySelector("subscription-selects");
    this.addEventListener("change", this.onVariantChange);
  }

  /*
  detect if sub was selection was done
  detect if init is sub or nah
  */
  subscriptionChangeUnsubscriber = undefined;

  connectedCallback() {
    if (!this.subscriptionSelects) return;

    // get saved info for subs
    this.subscriptionChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.subscriptionChange,
      (event) => {
        this.selectedPlan = event.data.selling_plan;
        this.selectedPurchaseOption = event.data.purchase_option;
        this.newPrice = event.data.new_price;
      }
    );
  }

  disconnectedCallback() {
    if (this.subscriptionChangeUnsubscriber) {
      this.subscriptionChangeUnsubscriber();
    }
  }

  getPriceString() {
    if (
      this.selectedPurchaseOption &&
      this.selectedPurchaseOption.value === "subscription"
    ) {
      return this.newPrice;
    }

    const priceString = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: window.currencyStrings.currency,
      trailingZeroDisplay: "stripIfInteger",
    }).format(this.currentVariant.price / 100);

    return priceString;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButtons(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButtons(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    // const productForms = document.querySelectorAll(
    //   `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    // );

    const productForms = document.querySelectorAll(`[id^=product-form]`);

    if (!productForms || productForms?.length < 1) return;

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );

        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButtons(disable = true, text, modifyClass = true, priceText) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;

    const addButtons = productForm.querySelectorAll('[name="add"]');
    if (!addButtons) return;

    addButtons.forEach((addButton) => {
      const addButtonText = productForm.querySelector(
        '[name="add"] > .prices > .js-atc-price'
      );

      if (disable) {

      } else {
        addButton.removeAttribute("disabled");
        if (priceText) {
          addButtonText.textContent = `${
            this.selectedPurchaseOption?.value === "one-time-purchase" ||
            (!this.selectedPurchaseOption?.value &&
              window.subs?.defaultSetting === "one-time-purchase")
              ? window.variantStrings.addToCart
              : window.variantStrings.subscibe
          } - ${priceText}`;
        } else {
          addButtonText.textContent = `${
            this.selectedPurchaseOption?.value === "one-time-purchase" ||
            (!this.selectedPurchaseOption?.value &&
              window.subs?.defaultSetting === "one-time-purchase")
              ? window.variantStrings.addToCart
              : window.variantStrings.subscibe
          }`;
        }
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (this.getAttribute("data-autoplay") === "true") {
      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      };

      const observerCallback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting & (this.querySelector("video") == null)) {
            this.loadContent.bind(this)(false);
          } else if (
            entry.isIntersecting &
            (this.querySelector("video") !== null)
          ) {
            this.querySelector("video").play();
            // console.log("play");
          } else if (
            !entry.isIntersecting &
            (this.querySelector("video") !== null)
          ) {
            // console.log("pause");
            this.querySelector("video").pause();
          }
        });
      };

      const observer = new IntersectionObserver(
        observerCallback,
        observerOptions
      );
      observer.observe(this);
    } else {
      poster.addEventListener("click", this.loadContent.bind(this));
    }
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );
      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      // Hide the poster button
      const poster = this.querySelector("img");
      if (poster) poster.style.display = "none";

      //Unmute video
      if (deferredElement.nodeName === "VIDEO") {
        deferredElement.muted = false;
      }

      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

let lastScrollPosition = 0;
let ticking = false;

function update() {
  const currentScrollPosition = window.pageYOffset;

  if (currentScrollPosition < lastScrollPosition) {
    // User is scrolling up, show the announcement bar.
    document.documentElement.dataset.scrollDirection = "up";
  } else if (currentScrollPosition > 0) {
    // User is scrolling down, hide the announcement bar.
    document.documentElement.dataset.scrollDirection = "down";
  }

  if (
    currentScrollPosition !== 0 &&
    document.documentElement.dataset.scrolled !== true
  ) {
    document.documentElement.dataset.scrolled = true;
  } else if (currentScrollPosition === 0) {
    document.documentElement.dataset.scrolled = false;
  }

  lastScrollPosition = currentScrollPosition;
  ticking = false;
}

window.addEventListener("scroll", () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      ticking = true;
      update();
    });
  }
});

class SlidingDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawerElement = this.querySelector(".js-drawer");
    this.drawerToggle = this.querySelector(".js-drawer-toggle");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  static get observedAttributes() {
    return ["data-open"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-open") {
      this.enabled = this.hasAttribute("data-open");
    }
  }

  bindEvents() {
    this.querySelector(".js-drawer-toggle").addEventListener(
      "click",
      this.onDrawerToggleClick.bind(this)
    );
    this.querySelector(".js-drawer-close").addEventListener(
      "click",
      this.closeDrawer.bind(this)
    );
  }

  onDrawerToggleClick(event) {
    const isOpen = this.hasAttribute("data-open");

    //To Do: Add trap focus
    if (isOpen) event.preventDefault();
    isOpen ? this.closeDrawer(event, this.drawerElement) : this.openDrawer();
  }

  onKeyUp(event) {
    const isOpen = this.hasAttribute("data-open");
    if (event.code.toUpperCase() !== "ESCAPE") return;

    if (event.target === this.drawerToggle && isOpen) {
      this.closeDrawer(event, this.drawerElement);
    }
  }

  openDrawer() {
    setTimeout(() => {
      this.drawerToggle.classList.add("drawer-opening");
    });
    console.log("tooggle open?");
    this.drawerElement.setAttribute("aria-expanded", true);
    this.drawerElement.classList.add("drawer--open");
    //To Do: Add trap focus
    trapFocus(
      this.drawerElement,
      this.querySelector('input:not([type="hidden"])') || this.drawerElement
    );
    document.body.classList.add(`overflow-hidden`);
  }

  closeDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.drawerElement.classList.remove("drawer--open");
    this.drawerToggle.classList.remove("drawer-opening");
    this.drawerElement.setAttribute("aria-expanded", false);
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation();

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.hasAttribute("data-open") &&
        !this.drawerElement.contains(document.activeElement)
      )
        this.closeDrawer();
    });
  }

  closeAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        this.removeAttribute("data-open");
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("sliding-drawer", SlidingDrawer);

class TabMenu extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  connectedCallback() {}

  bindEvents() {
    this.querySelectorAll(".js-tab-heading").forEach((heading) =>
      heading.addEventListener("click", this.onTabHeadingClick.bind(this))
    );
  }

  onTabHeadingClick(event) {
    const allTabHeadings = this.querySelectorAll(".js-tab-heading");
    const tabHeading = event.target;
    const tabIndex = tabHeading.dataset.index;
    const tabContents = this.querySelectorAll(".js-tab-content");
    const activeTabContent = this.querySelector(
      `.js-tab-content[data-index="${tabIndex}"]`
    );

    tabContents.forEach((tabContent) => {
      tabContent.classList.remove("tab-content--active");
      tabContent.removeAttribute("inert");
    });
    activeTabContent.classList.add("tab-content--active");
    activeTabContent.removeAttribute("inert");

    allTabHeadings.forEach((tabHeading) => {
      tabHeading.classList.remove("tab-heading--active");
      tabHeading.setAttribute("aria-expanded", false);
    });

    tabHeading.setAttribute("aria-expanded", true);

    tabHeading.classList.add("tab-heading--active");
  }
}

customElements.define("tab-menu", TabMenu);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    this.headerOverlay = this.querySelector(".js-header-overlay");
    this.container = this.querySelector(".js-header-container");
    this.searchToggle = this.querySelector("#search-toggle");
    this.desktopSearch = this.querySelector("#desktop-search");
  }

  static get observedAttributes() {
    return ["data-submenu"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-submenu") {
      this.submenu = this.hasAttribute("data-submenu");
    }
  }

  bindEvents() {
    this.querySelectorAll(".js-desktop-nav-item").forEach((item) =>
      item.addEventListener("mouseenter", this.onMouseEnter.bind(this))
    );
    this.querySelectorAll(".js-desktop-nav-item").forEach((item) =>
      item.addEventListener("mouseleave", this.onMouseLeave.bind(this))
    );
    this.querySelector("#search-toggle").addEventListener(
      "click",
      this.onSearchToggleClick.bind(this)
    );

    this.querySelector("#desktop-search-close").addEventListener(
      "click",
      this.closeSearch.bind(this)
    );
    this.querySelector(".js-header-overlay").addEventListener(
      "click",
      this.handleOverlayClick.bind(this)
    );
  }
  handleOverlayClick(event) {
    if (this.dataset.searchOpen === "true") {
      this.closeSearch();
    }
  }
  onMouseEnter(event) {
    if (event.target.hasAttribute("data-submenu")) {
      this.closeSearch(true);
      this.classList.add("header--submenu-active");
      document.body.classList.add(`overflow-hidden`);
      const height = event.target.querySelector(
        ".js-desktop-nav-submenu"
      ).offsetHeight;
      this.style.setProperty("--submenu-height", `${height}px`);
    }
  }
  onMouseLeave(event) {
    if (event.target.hasAttribute("data-submenu")) {
      document.body.classList.remove(`overflow-hidden`);
      this.classList.remove("header--submenu-active");
      this.style.setProperty("--submenu-height", `0px`);
    }
  }
  openSearch() {
    this.setAttribute("data-search-open", "true");
    this.classList.add("header--submenu-active");
    document.body.classList.add(`overflow-hidden`);
    this.style.setProperty("--submenu-height", `var(--desktop-search-height)`);
    this.desktopSearch.classList.add("desktop-search--active");
    trapFocus(
      this.desktopSearch,
      this.desktopSearch.querySelector('input:not([type="hidden"])')
    );
    this.searchToggle.setAttribute("aria-expanded", "true");
  }
  closeSearch(closeBackground = true) {
    if (closeBackground) {
      this.classList.remove("header--submenu-active");
      this.style.setProperty("--submenu-height", `0px`);
    }
    this.setAttribute("data-search-open", "false");
    document.body.classList.remove(`overflow-hidden`);
    this.desktopSearch.classList.remove("desktop-search--active");
    removeTrapFocus(this.desktopSearch);
    this.searchToggle.setAttribute("aria-expanded", "false");
  }
  onSearchToggleClick(event) {
    if (this.desktopSearch.classList.contains("desktop-search--active")) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }
}

customElements.define("header-menu", HeaderMenu);

class MyFooter extends HTMLElement {
  constructor() {
    super();
    const stickyShopBanner = document.querySelector(".js-sticky-shop-banner");

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          document.body.classList.add("footer-visible");
        } else {
          document.body.classList.remove("footer-visible");
        }
      });
    };
    if (stickyShopBanner) {
      const observer = new IntersectionObserver(
        observerCallback,
        observerOptions
      );
      observer.observe(this);
    }
    // currency converter in footer
    const localizationForm = this.querySelector("#localization_form");
    const selects = localizationForm?.querySelectorAll("select");

    if (selects && localizationForm) {
      selects.forEach(function (select) {
        select.addEventListener("change", function (event) {
          localizationForm.submit();
        });
      });
    }
  }
}
customElements.define("my-footer", MyFooter);

class NewsletterSignup extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.emailInput = this.querySelector(".js-email-input");
    this.errorMessage = this.querySelector(".js-newsletter-error");
    this.ListId = this.form.dataset.klaviyoListId;
    this.successMessage = this.querySelector(".js-newsletter-success");
    this.form.setAttribute("novalidate", "true");
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    const email = this.emailInput.value;
    const LIST_ID = this.ListId;
    const klaviyoId = LIST_ID ? LIST_ID : window && window.klaviyo_list_id;
    const g = klaviyoId || LIST_ID;

    // Simple email validation
    if (
      !/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
        email
      )
    ) {
      this.errorMessage.textContent = "Please enter a valid email address.";
      return;
    }

    try {
      const response = await fetch(
        "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Cache-Control": "no-store",
            Pragma: "no-cache",
          },
          body: new URLSearchParams({
            email,
            g,
            $consent: ["email"],
            $fields: "$consent,$source",
            $list_fields: "$consent",
            $source: "footer",
          }),
        }
      );

      const data = await response.json();

      // Check if there are errors in response
      if (data.errors && data.errors.length > 0) {
        errorMessage.textContent = data.errors.join(", ");
        return;
      }

      // Hide form and display success message
      this.errorMessage.textContent = "";
      this.emailInput.value = "";
      this.emailInput.blur();
      this.successMessage.style.display = "block";
    } catch (error) {
      console.error(error);
      this.errorMessage.textContent = "An error occurred, please try again.";
    }
  }
}

customElements.define("newsletter-signup", NewsletterSignup);

class CustomerLogin extends HTMLElement {
  constructor() {
    super();
    const recoverLink = document.querySelector(".js-recover-link");
    const recoverPwDiv = document.querySelector(".js-recover-pw");
    const loginForm = document.querySelector("#customer_login");
    const loginHeading = document.querySelector("#login");

    recoverLink?.addEventListener("click", this.onRecoveryClick);
    const currentUrl = window.location.href;

    if (currentUrl.includes("#recover")) {
      recoverPwDiv.style.display = "block";
      loginForm.style.display = "none";
      loginHeading.innerHTML = "Recover Password";
    } else {
      recoverPwDiv.style.display = "none";
      loginForm.style.display = "block";
      loginHeading.innerHTML = "Login";
    }
  }

  onRecoveryClick() {
    const recoverPwDiv = document.querySelector(".js-recover-pw");
    const loginForm = document.querySelector("#customer_login");
    const loginHeading = document.querySelector("#login");
    loginHeading.innerHTML = "Recover Password";
    recoverPwDiv.style.display = "block";
    loginForm.style.display = "none";
  }
}
customElements.define("customer-login", CustomerLogin);

function throttle(fn, delay = 100) {
  let lastCall = 0;

  return function (...args) {
    const now = new Date().getTime();

    if (now - lastCall >= delay) {
      lastCall = now;
      fn.apply(this, args);
    }
  };
}

function getFlagEmojiByCountryCode(countryCode) {
  return countryCode.toUpperCase().replace(/./g, char =>
    String.fromCodePoint(127397 + char.charCodeAt())
  );
}

/* ---------------------------------------------------------------------------------------------------------------------
    LOCALIZATION SELECTOR
   ------------------------------------------------------------------------------------------------------------------ */

class LocalizationSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");
    this.select = this.querySelector("select");
    this.optionElements = Array.from(this.querySelectorAll("option"));

    this._onSelectChanged = this._onSelectChange.bind(this);

    this._initOptions();

    this.form.addEventListener("change", this._onSelectChanged);
  }

  disconnectedCallback() {
    this.form.removeEventListener("change", this._onSelectChanged);
  }

  _onSelectChange() {
    this.form.submit();
  }

  _initOptions() {
    this.optionElements.forEach((optionElement) => {
      optionElement.innerHTML = `${getFlagEmojiByCountryCode(optionElement.value)}&ensp;${optionElement.value}`
    });
  }
}

if (!customElements.get("localization-selector")) {
  customElements.define("localization-selector", LocalizationSelector);
}

/* ------------------------------------------------------------------------------------------------------------------ */
